import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

// Handles the return from Emergent Google sign-in: {origin}/compte#session_id=...
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/compte";
    (async () => {
      try {
        const data = await googleSession(sid);
        toast.success(`Bienvenue ${data.name || ""}`.trim());
        navigate(data.role === "admin" ? "/admin" : target, { replace: true, state: { user: data } });
      } catch (e) {
        console.warn("google session exchange failed", e?.response?.status);
        toast.error(e.response?.data?.detail || "Connexion Google impossible");
        navigate("/compte", { replace: true });
      }
    })();
  }, [location.hash, location.pathname, googleSession, navigate]);

  return <div className="min-h-screen pt-40 text-center text-stone-500 font-mono text-sm" data-testid="auth-callback">Connexion…</div>;
}
